import type { Component } from '@builder.io/sdk';

export const RichTextFields = {};

const RichTextBuilderConfig = {
  name: 'richText',
  inputs: [
    {
      name: 'text',
      type: 'richText',
      defaultValue: '<p>Here is your Copy. Click on me to edit content!</p>',
      helperText: 'Main body content. You can add paragraphs, links, or inline formatting.',
    },
    {
      name: 'isBullet',
      type: 'boolean',
      defaultValue: false,
      helperText: 'Enable this option to render the content as a bulleted list.',
    },
  ],
} satisfies Component;

export default RichTextBuilderConfig;
